document.addEventListener('addToCartCustom', function(event) {
    console.log('Event addToCartCustom detected:', event.detail);

    let properties = {};
    const { id, qty } = event.detail;
    if (event.detail?.properties) {
        properties = event.detail.properties;
    }    
    addToCartAndRefresh(id, qty, properties);

});

function updateCartCounter() {
    const cartDrawerCounter = document.querySelector(
        ".cart-drawer__title-counter"
    );

    fetch("/cart.json", {
        method: "GET",
        headers: {
            Accept: "application/json"
        }
    })
    .then(response => response.json())
    .then(data => (cartDrawerCounter.innerHTML = data.item_count))
    .catch(error => console.error('Error updating cart counter:', error));
}

function addToCartAndRefresh(vid, quantity = 1, properties = {}) {
    const formData = {
        items: [{
        id: vid,
        quantity: quantity,
        properties: properties
        }],
        sections: ['cart-drawer', 'cart-counter'],
    };

    fetch('/cart/add.js', {
        method: 'POST',
        headers: {
        'Content-Type': 'application/json'
        },
        body: JSON.stringify(formData)
    })
    .then(response => response.json())
    .then(json => {
        let cartDrawer = document.querySelector("cart-drawer");
        cartDrawer.renderContents(json, true, false);

        updateCartCounter();
    })
    .catch(error => console.error('Error adding to cart:', error));
}

window.refreshCart = function refreshCart() {
    fetch('/?sections=cart-drawer,cart-counter', {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json'
        }
    })
    .then(response => response.json())
    .then(json => {
        console.log(json);
        let cartDrawer = document.querySelector("cart-drawer");
        cartDrawer.renderContents({ sections: json }, true, false);

        updateCartCounter();
    })
    .catch(error => console.error('Error refreshing cart:', error));
}

// document.addEventListener("click", function (e) {
//     if (e.target.matches("[data-rt-add-to-cart]")) {
//         e.preventDefault();
//         const button = e.target;
//         const variantId = button.dataset.rtVariantId;
//         const dataVariantId = button.getAttribute("data-rt-variant-id");

//         document.dispatchEvent(
//             new CustomEvent("addToCartCustom", {
//                 detail: { id: dataVariantId, qty: 1, properties: { _gift_product: "yes" } },
//             })
//         );
//     }
// });

window.addEventListener("load", function () {
  const rtAddToCartButtons = document.querySelectorAll("[data-rt-add-to-cart]");
  if (rtAddToCartButtons?.length > 0) {
    rtAddToCartButtons.forEach((button) => {
      button.addEventListener("click", function (e) {
        e.preventDefault();
        const variantId = button.dataset.rtVariantId;
        const dataVariantId = button.getAttribute("data-rt-variant-id");

        document.dispatchEvent(
          new CustomEvent("addToCartCustom", {
            detail: { id: dataVariantId, qty: 1, properties: { _gift_product: "yes" } },
          })
        );
      });
    });
  }
  const rtDefaultButtons = document.querySelectorAll("[data-rt-default-add-to-cart]");
  if (rtDefaultButtons?.length > 0) {
    rtDefaultButtons.forEach((button) => {
      button.addEventListener("click", function (e) {
        e.preventDefault();
        const variantId = button.dataset.rtVariantId;
        const dataVariantId = button.getAttribute("data-rt-variant-id");
        document.dispatchEvent(
          new CustomEvent("addToCartCustom", {
            detail: { id: dataVariantId, qty: 1 },
          })
        );
      });
    });
  }  
});
